import { UseVyStepper, useVyStepper } from '../../../../../../../../hooks/use-vy-stepper';
import { CREATE_NEW_CONTRACT_STEPS } from '../renew-contract-dialog-types/create-new-contract-steps';
import {
  RenewContractStepFlowConfig,
  RenewContractStepViewConfig,
} from '../renew-contract-dialog-types/renew-contract-step-view-config';
import { RenewContractNewTermsStepDetails } from '../renew-contract-dialog-components/RenewContractNewTermsStepDetails';
import { RenewContractNewTermsStepCreate } from '../renew-contract-dialog-components/RenewContractNewTermsStepCreate';
import type { CreateNewContractStep } from '../renew-contract-dialog-types/create-new-contract-steps';
import { getOptionalObjectProperty, isNotNullOrUndefined, Optional } from '@vy/utils';

export function useRenewContractNewTermsFlow(): RenewContractStepFlowConfig {
  const stepper = useVyStepper<CreateNewContractStep>(
    CREATE_NEW_CONTRACT_STEPS.Details,
    CREATE_NEW_CONTRACT_STEPS,
  );
  const stepViewMap = getRenewContractNewTermsStepViewMap(stepper);

  const getStepView = (step: CreateNewContractStep): Optional<RenewContractStepViewConfig> => {
    return getOptionalObjectProperty(stepViewMap, step);
  };

  const goToPreviousStep = () => stepper.previousStep();

  return {
    getStepView,
    isFirstStep: stepper.isFirstStep,
    goToPreviousStep,
    currentStep: stepper.currentStep,
  };
}

function getRenewContractNewTermsStepViewMap(
  stepper: UseVyStepper<CreateNewContractStep>,
): Record<CreateNewContractStep, RenewContractStepViewConfig> {
  return {
    [CREATE_NEW_CONTRACT_STEPS.Details]: {
      label: 'Start a new contract from blank',
      ctaText: 'Next',
      content: <RenewContractNewTermsStepDetails />,
      onNext: () => {
        stepper.nextStep();
      },
    },
    [CREATE_NEW_CONTRACT_STEPS.Create]: {
      label: 'Create a new contract',
      labelDescription: 'Assign your plan to a customer and select a starting date',
      ctaText: 'Go to plan builder',
      onNext: () => {
        const form = document.querySelector('form');

        if (isNotNullOrUndefined(form)) {
          form.requestSubmit();
        }
      },
      content: <RenewContractNewTermsStepCreate />,
    },
  };
}
